type Props = {
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
};

const RestockIcon = ({
  fill = 'none',
  stroke = '#8907E7',
  width = 16,
  height = 16
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.43466 2.22988C6.70798 2.07928 7.0179 2 7.33337 2C7.64886 2 7.95879 2.07929 8.23212 2.2299L8.23337 2.23059L12.4334 4.52547C12.6539 4.64723 12.8443 4.81201 12.9926 5.00837C13.0305 5.04391 13.0641 5.08488 13.0919 5.13094C13.1162 5.17103 13.1348 5.21275 13.148 5.25527C13.2694 5.49093 13.3331 5.75055 13.3334 6.01428V10.6052C13.3331 10.907 13.2497 11.2035 13.0918 11.4648C12.9338 11.7261 12.7067 11.9431 12.4334 12.094L12.4311 12.0953L8.23337 14.3889L8.2323 14.3895C8.04231 14.4942 7.83463 14.5645 7.6197 14.5976C7.53477 14.6416 7.43749 14.6666 7.33409 14.6666C7.23094 14.6666 7.13387 14.6417 7.04909 14.5979C6.83344 14.5649 6.62506 14.4946 6.43448 14.3895L6.43337 14.3889L2.23569 12.0953L2.23337 12.094C1.96001 11.9431 1.73296 11.7261 1.57499 11.4648C1.41702 11.2035 1.3337 10.907 1.33337 10.6052V6.01428C1.33366 5.74606 1.3995 5.48209 1.52501 5.24325C1.5379 5.20489 1.55523 5.16724 1.5772 5.13094C1.60298 5.08832 1.63362 5.05006 1.66806 5.01643C1.81722 4.81651 2.00981 4.64889 2.23337 4.52547L2.23569 4.5242L6.43466 2.22988ZM7.93409 13.2309L11.8334 11.1003L11.8343 11.0998C11.925 11.0495 12.0004 10.9774 12.0528 10.8906C12.1055 10.8035 12.1333 10.7047 12.1334 10.604V6.32394L7.93409 8.64669V13.2309ZM6.73409 8.64617V13.2317L2.83337 11.1003L2.83243 11.0998C2.74173 11.0495 2.66639 10.9774 2.61391 10.8906C2.5613 10.8035 2.53353 10.7048 2.53337 10.6043V6.32263L6.73409 8.64617ZM7.63337 3.22431L11.5106 5.34282L7.33456 7.65271L3.15734 5.34217L7.03106 3.22558L7.03337 3.22431C7.12459 3.17395 7.22805 3.14744 7.33337 3.14744C7.4387 3.14744 7.54216 3.17396 7.63337 3.22431Z"
        fill={stroke}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 1.72918C14 1.51056 13.8135 1.33334 13.5833 1.33334C13.3532 1.33334 13.1667 1.51056 13.1667 1.72918V2.50001H12.3958C12.1772 2.50001 12 2.68656 12 2.91668C12 3.1468 12.1772 3.33334 12.3958 3.33334H13.1667V4.10418C13.1667 4.32279 13.3532 4.50001 13.5833 4.50001C13.8135 4.50001 14 4.32279 14 4.10418V3.33334H14.7708C14.9894 3.33334 15.1667 3.1468 15.1667 2.91668C15.1667 2.68656 14.9894 2.50001 14.7708 2.50001H14V1.72918Z"
        fill={stroke}
      />
    </svg>
  );
};

export default RestockIcon;
